import classnames from 'classnames';
import React, { useRef } from 'react';

var SingleInput = function SingleInput(_ref, ref) {
  var disabled = _ref.disabled,
    dataTestId = _ref['data-testid'],
    id = _ref.id,
    isExpanded = _ref.isExpanded,
    maxLength = _ref.maxLength,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    placeholder = _ref.placeholder,
    required = _ref.required,
    searchText = _ref.searchText,
    selectedOption = _ref.selectedOption;
  var innerRef = useRef(null);
  if (ref) {
    if (typeof ref === 'function') {
      ref(innerRef.current);
    } else {
      ref.current = innerRef.current;
    }
  }
  var finalClasses = classnames('C-Autocomplete__Input', {
    isDisabled: disabled
  });
  return /*#__PURE__*/React.createElement("input", {
    autoComplete: "off",
    "aria-required": required ? 'true' : 'false',
    "data-test": id,
    "aria-controls": "ariaControls_".concat(id),
    "data-testid": dataTestId ? "".concat(dataTestId, "_input") : null,
    className: finalClasses,
    ref: innerRef,
    id: id,
    disabled: disabled,
    value: searchText,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    maxLength: maxLength,
    placeholder: placeholder,
    required: required,
    type: "text",
    role: "combobox",
    "aria-expanded": isExpanded,
    "aria-activedescendant": selectedOption ? selectedOption.id : ''
  });
};
SingleInput.displayName = 'SingleInput';
var SingleInput$1 = /*#__PURE__*/React.forwardRef(SingleInput);

export { SingleInput, SingleInput$1 as default };
